/**
 * Token storage. localStorage by default; swap via `setAuthStorage()` if a
 * stricter posture is needed later (cookies, sessionStorage, etc.).
 */

import { scopedKey } from "@/lib/tenant/basePath";

export interface AuthStorage {
  getAccess(): string | null;
  getRefresh(): string | null;
  set(tokens: { access: string; refresh: string }): void;
  clear(): void;
}

const KEYS = { access: scopedKey("drtutor.access"), refresh: scopedKey("drtutor.refresh") };

const localStorageAuth: AuthStorage = {
  getAccess: () =>
    typeof window === "undefined" ? null : localStorage.getItem(KEYS.access),
  getRefresh: () =>
    typeof window === "undefined" ? null : localStorage.getItem(KEYS.refresh),
  set: ({ access, refresh }) => {
    if (typeof window === "undefined") return;
    localStorage.setItem(KEYS.access, access);
    localStorage.setItem(KEYS.refresh, refresh);
  },
  clear: () => {
    if (typeof window === "undefined") return;
    localStorage.removeItem(KEYS.access);
    localStorage.removeItem(KEYS.refresh);
  },
};

let currentStorage: AuthStorage = localStorageAuth;

export const tokenStorage = {
  getAccess: () => currentStorage.getAccess(),
  getRefresh: () => currentStorage.getRefresh(),
  set: (tokens: { access: string; refresh: string }) =>
    currentStorage.set(tokens),
  clear: () => currentStorage.clear(),
};

export function setAuthStorage(storage: AuthStorage): void {
  currentStorage = storage;
}
